import { Routes } from '@angular/router';
import { ChatPageComponent } from './chat/chat-page.component';
import { proxyAuthGuard } from './guards/proxy-auth.guard';

export const routes: Routes = [
    { path: '', component: ChatPageComponent, canActivate: [proxyAuthGuard] }
];
